export default "__VITE_ASSET__Khk8U_ah__"